import { iconMap, unitMap } from "../core/_constant";
import { Target } from "./Target";

type TargetGlobalProps = {
  data?: Array<{ property: string; value: number }>;
};

export const TargetGlobal = ({ data = [] }: TargetGlobalProps) => {
  return (
    <div
      className="d-flex flex-wrap justify-content-between align-items-center bg-white rounded-3 sm:p-4 py-2"
      style={{
        border: "8px solid #fff",
      }}
    >
      {data?.map((item, idx) => (
        <>
          <Target
            key={idx}
            label={item.property}
            value={item.value}
            unit={unitMap[item.property] || ""}
            icon={
              <img
                className="icon-dashbord"
                src={iconMap[item.property]}
                alt={item.property}
              />
            }
          />
          <div
            className={`divider${idx === data.length - 1 ? " d-none" : ""}`}
          ></div>
        </>
      ))}
    </div>
  );
};
